import React from "react";

export const PersonalInformation = ({feature}) => (
    <div id="informacionpersonal" role="tabpanel" className="tab-pane fade in active">
        <h3 className="clearmargin hidden-xs">Información Personal</h3>
        <div className="panel panel-default margintop20">
            <div className="panel-body brandon">
                <div>
                    <div className="general-title">Email:</div>
                    <span>{feature.email}</span>
                </div>
                <div className="margintop20">
                    <div className="general-title">Nombre:</div>
                    <span>{feature.name}</span>
                </div>
                <div className="margintop20">
                    <div className="general-title">Apellido:</div>
                    <span>{feature.lastname}</span>
                </div>
                <div className="margintop20">
                    <div className="general-title">Rol:</div>
                    <span>
                        {feature.isAdministrator()
                            ? 'Administrador'
                            : feature.isBranchManager() ? 'Gerente sucursal' : 'Usuario'}
                    </span>
                </div>
                <hr/>
                <div className="margintop20">
                    <div className="general-title">Cliente:</div>
                    <span>{feature.name}</span>
                </div>
                <div className="margintop20">
                    <div className="general-title">Razón social:</div>
                    <span>{feature.socialReason}</span>
                </div>
                <div className="margintop20">
                    <div className="general-title">Puntos de Entrega:</div>
                    {feature.deliverySitesForCurrentUser().map((deliverySite, index) => (
                        <span key={index}>{deliverySite.NombreYDireccion}</span>
                    ))}
                </div>
            </div>
        </div>
    </div>
);